// PB-74 — Globo Smart Product Filter & Search integration glue.
//
// Globo re-renders the product grid / filter tree by injecting raw HTML
// outside of Alpine's own root, so x-data components inside that HTML
// (e.g. xProductForm in the theme cards swapped in by syncThemeCards) are inert
// until Alpine walks them explicitly. This follows the same guarded
// Alpine.initTree() idiom already used in assets/cart-drawer.js and
// assets/pdp-mediashop.js for the identical problem.
//
// Event names per Globo's documented storefront JS events
// (docs.globo.io/javascript-events/storefront-javascript-events.md):
//   globoFilterRenderCompleted      - product grid re-rendered
//   globoFilterTreeRenderCompleted  - filter sidebar/tree re-rendered
(function () {
  function reinitAlpine(root) {
    if (!window.Alpine || typeof window.Alpine.initTree !== "function") return;
    if (!root) return;
    if (!root._x_dataStack) {
      try {
        window.Alpine.initTree(root);
      } catch (e) {
        if (typeof console !== "undefined" && console.warn) {
          console.warn("[globo-integration] Alpine.initTree failed", e);
        }
      }
    }
    root.querySelectorAll("[x-data]").forEach(function (el) {
      if (!el._x_dataStack) {
        try {
          window.Alpine.initTree(el);
        } catch (e) {
          if (typeof console !== "undefined" && console.warn) {
            console.warn("[globo-integration] Alpine.initTree failed on child", e);
          }
        }
      }
    });
  }

  // TODO-GLOBO: confirm the exact shape of `event.detail` for each event
  // (container element vs. list of product ids) against the real app once
  // live on staging, and narrow `document.body` down to the specific
  // container Globo rendered into instead of re-scanning the whole page.
  window.addEventListener("globoFilterRenderCompleted", function () {
    reinitAlpine(document.body);
  });

  window.addEventListener("globoFilterTreeRenderCompleted", function () {
    reinitAlpine(document.body);
  });

  // PB-74 follow-up — horizontal filter bar (Globo admin: Filter panel
  // layout = Horizontal). Merges the native sort control + product count
  // visually into the same row as Globo's filter bar by relocating them
  // into #ms-collection-toolbar-slot, a stable sibling of #gf-tree added in
  // sections/mediashop-static-collection-grid.liquid. That slot is never
  // rewritten by Globo's own re-render of #gf-tree or by this file's own
  // sort-AJAX root.replaceWith, so moving real DOM nodes into it (not
  // cloning) is safe — their listeners/state move with them.
  //
  // Idempotent by construction: once a node is inside the slot, it's no
  // longer a descendant of [data-ms-collection-grid-root], so a repeat call
  // finds nothing to move and no-ops. Only a genuine root replacement
  // (fresh nodes back inside the new root) makes there be something to move
  // again — exactly when re-relocation is needed.
  function relocateToolbarControls() {
    // Only meaningful in horizontal mode — the CSS that lays out
    // #ms-collection-toolbar-slot alongside #gf-tree is entirely scoped to
    // html.gf-top_one, so moving the sort control there in vertical-sidebar
    // mode would just make it disappear into an unstyled div.
    if (!document.documentElement.classList.contains("gf-top_one")) return;
    var slot = document.getElementById("ms-collection-toolbar-slot");
    var root = document.querySelector("[data-ms-collection-grid-root]");
    if (!slot || !root) return;

    var hasSectionClass = Array.prototype.some.call(slot.classList, function (c) {
      return c.indexOf("section--") === 0;
    });
    if (!hasSectionClass) {
      var sectionClass = Array.prototype.find.call(root.classList, function (c) {
        return c.indexOf("section--") === 0;
      });
      if (sectionClass) slot.classList.add(sectionClass);
    }

    var sortEl = root.querySelector(".ms-collection-sort");
    var countEl = root.querySelector(".ms-collection-grid__count");
    if (sortEl && sortEl.parentElement !== slot) slot.appendChild(sortEl);
    if (countEl && countEl.parentElement !== slot) slot.insertBefore(countEl, slot.firstChild);
  }

  // PB-74 follow-up — the merged count ("N Produkte") never changed when a
  // Globo filter was applied (only a sort-change re-fetches the section's
  // server-rendered count; Globo's own filtering is a separate client-side
  // XHR that only touches #gf-products, confirmed live 2026-10-14: picking
  // a collection filter that actually narrows the result set left the count
  // showing the original unfiltered total). Globo does track the live
  // filtered total itself — it's already in this file's own template
  // (snippets/globo.filter.tree.liquid's mobile-canvas footer button, "View
  // <b>{{pagination.total}}</b> Products") and updates correctly on every
  // globoFilterTreeRenderCompleted. Read that instead of trying to re-derive
  // the count ourselves.
  //
  // The search page (sections/ms-main-search.liquid) renders its count with
  // data-ms-count-pending: Shopify's native result count differs from
  // Globo's, so it stays hidden until it holds Globo's total.
  function syncFilteredCount() {
    if (!document.documentElement.classList.contains("gf-top_one")) return;
    var countEl = document.querySelector("#ms-collection-toolbar-slot .ms-collection-grid__count");
    var totalEl = document.querySelector('#gf-tree .gf-filter-footer button[onclick*="toggleCanvas"] b');
    if (!countEl || !totalEl) return;
    var total = totalEl.textContent.trim();
    if (!/^\d+$/.test(total)) return;
    countEl.textContent = countEl.textContent.replace(/^\d+/, total);
    countEl.removeAttribute("data-ms-count-pending");
  }

  // Search page with zero results: assets/globo-filter-tree.css hides the
  // filter bar (filter, count, sort) while .ms-search-page has
  // data-ms-search-empty. The section sets it from Shopify's own count;
  // this replaces it with Globo's total after every render. The bar stays
  // visible while a filter is active, so a filter that narrows the results
  // to zero can still be removed. Active filters are read from the chips
  // and from the URL: Globo renders no chip for a selected value without
  // hits (e.g. ?filter.910529=autozubehoer on a search that has none).
  function hasActiveGloboFilter() {
    if (document.querySelector("#gf-tree .globo-selected-items .selected-item")) return true;
    return Array.from(new URLSearchParams(window.location.search).keys()).some(function (key) {
      return key.indexOf("filter.") === 0;
    });
  }

  function syncSearchEmptyState() {
    var page = document.querySelector(".ms-search-page");
    if (!page || !document.documentElement.classList.contains("gf-top_one")) return;
    var totalEl = document.querySelector('#gf-tree .gf-filter-footer button[onclick*="toggleCanvas"] b');
    if (!totalEl) return;
    var total = totalEl.textContent.trim();
    if (!/^\d+$/.test(total)) return;
    var hasActiveFilter = hasActiveGloboFilter();
    if (total === "0" && !hasActiveFilter) {
      page.setAttribute("data-ms-search-empty", "");
    } else {
      page.removeAttribute("data-ms-search-empty");
    }
  }

  // PB-74 follow-up — tried relocating .globo-selected-items-wrapper out of
  // #gf-tree (into a new sibling slot, same pattern as
  // relocateToolbarControls above) so its background could span the full
  // grid width. Reverted, 2026-10-14: after the move, the wrapper's pills
  // never got populated on a real filter selection — confirmed live
  // (selected a filter, URL/count/grid all updated correctly, but the
  // relocated wrapper stayed childless). Globo evidently populates the
  // selected-pills markup via a later, #gf-tree-scoped update pass after its
  // own initial tree swap (the one globoFilterTreeRenderCompleted fires
  // for) — moving the node out from under #gf-tree before that second pass
  // runs makes Globo unable to find it again. Pills stay inside #gf-tree.
  //
  // Instead: #gf-tree shares its outer row with #ms-collection-toolbar-slot
  // (the merged sort control), so #gf-tree's own box is narrower than the
  // full 1300px grid row — a pills row sized to 100% of #gf-tree would wrap
  // its pills well short of the grid's right edge below it. Set its real
  // width in pixels here, to match the outer row's actual rendered width
  // (.ms-collection-filterbar__inner, sections/mediashop-static-collection-grid.liquid),
  // instead of a CSS percentage that can only ever resolve against
  // #gf-tree's own (narrower) box. #gf-tree itself has no overflow:hidden
  // anywhere in its ancestor chain, so the pills row rendering wider than
  // #gf-tree's own box is safe. The beige band behind it is full-bleed in
  // CSS regardless of this width.
  function syncPillsRowWidth() {
    if (!document.documentElement.classList.contains("gf-top_one")) return;
    var outer = document.querySelector(".ms-collection-filterbar__inner");
    var wrapper = document.querySelector("#gf-tree .globo-selected-items-wrapper");
    if (!outer || !wrapper) return;
    wrapper.style.width = outer.getBoundingClientRect().width + "px";
  }

  // PB-74 follow-up — search page sort (Globo's own control, positioned into
  // the filter bar by assets/globo-filter-tree.css). Globo renders its options
  // and labels from its API response (the Globo admin's sort list, English
  // labels); overriding GloboEmbedFilterConfig.shop.sorts or
  // GloboFilterTranslation before its bootstrap only changed the toggle
  // label, not the list (confirmed live, 2026-10-14). So after each render,
  // keep only the options in the section's data-ms-sort-labels (the
  // collection sort's options, plus Relevanz), in that order and with those
  // labels, and label the toggle for the active sort: the option Globo
  // rendered as aria-selected (the URL's sort_by isn't updated yet when this
  // event fires after a sort change — confirmed live, 2026-10-14), else
  // sort_by, else relevance. Globo looks its options up again on every
  // interaction and sets the toggle text from the clicked option, so the
  // removed and relabelled options stay consistent with its keyboard and
  // click handling.
  function alignSearchSortOptions() {
    var slot = document.querySelector(".ms-search-page #ms-collection-toolbar-slot[data-ms-sort-labels]");
    var sort = document.querySelector(".ms-search-page #gf-controls-container .sort-by:not(.limit-by)");
    var list = sort && sort.querySelector('[role="listbox"]');
    if (!slot || !list) return;
    var labels;
    try {
      labels = JSON.parse(slot.getAttribute("data-ms-sort-labels"));
    } catch (e) {
      return;
    }
    Array.prototype.forEach.call(list.querySelectorAll("li[data-sort]"), function (option) {
      var value = option.getAttribute("data-sort");
      if (!Object.prototype.hasOwnProperty.call(labels, value)) {
        option.remove();
        return;
      }
      option.textContent = labels[value];
      option.setAttribute("aria-label", labels[value]);
    });
    Object.keys(labels).forEach(function (value) {
      var option = list.querySelector('li[data-sort="' + value + '"]');
      if (option) list.appendChild(option);
    });
    var selected = list.querySelector('li[data-sort][aria-selected="true"]');
    var current = selected
      ? selected.getAttribute("data-sort")
      : new URL(window.location.href).searchParams.get("sort_by") || "relevance";
    var toggleLabel = sort.querySelector(".sort-by-toggle span");
    if (toggleLabel && labels[current]) toggleLabel.textContent = labels[current];
  }

  // Globo renders its template with its own engine, which can't render theme
  // snippets, and its product data has no metafields or description. So its
  // card (snippets/globo.filter.product.liquid) is only a placeholder: after
  // each render, every placeholder is replaced by the theme's own card
  // (snippets/mediashop-product-card.liquid via the ms-card-mediashop section,
  // which assets/product-card.js also fetches). Globo only decides which
  // products appear, and in which order. On any error the placeholder stays, a
  // plain link to the product.
  var CARD_SYNC_CONCURRENCY = 6;
  var CARD_SYNC_TIMEOUT_MS = 8000;
  // A Map, so handles like "constructor" don't hit Object.prototype.
  var themeCardRequests = new Map();
  var themeCardQueue = [];
  var themeCardActive = 0;

  function loadThemeCard(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var url = new URL(root + "products/" + encodeURIComponent(handle), window.location.origin);
    url.searchParams.set("section_id", "ms-card-mediashop");
    var options = { credentials: "same-origin" };
    // A stalled request would hold one of the few queue slots indefinitely.
    if (typeof AbortSignal !== "undefined" && typeof AbortSignal.timeout === "function") {
      options.signal = AbortSignal.timeout(CARD_SYNC_TIMEOUT_MS);
    }
    return fetch(url.href, options)
      .then(function (response) {
        if (!response.ok) throw new Error("Theme card response " + response.status);
        if (response.url && new URL(response.url).origin !== window.location.origin) {
          throw new Error("Invalid theme card response origin");
        }
        return response.text();
      })
      .then(function (html) {
        var page = new DOMParser().parseFromString(html, "text/html");
        var template = page.querySelector('template[data-native-card-template="mediashop"]');
        var card = template && template.content.querySelector(".ms-top-card");
        ["media", "title", "price"].forEach(function (part) {
          if (!card || !card.querySelector('[data-card-part="' + part + '"]')) {
            throw new Error("Incomplete theme card for " + handle);
          }
        });
        // Shared by every placeholder of this product: copy it, never change it.
        return card;
      });
  }

  function pumpThemeCardQueue() {
    while (themeCardActive < CARD_SYNC_CONCURRENCY && themeCardQueue.length) {
      var job = themeCardQueue.shift();
      themeCardActive++;
      loadThemeCard(job.handle)
        .then(job.resolve, job.reject)
        .finally(function () {
          themeCardActive--;
          pumpThemeCardQueue();
        });
    }
  }

  function themeCard(handle) {
    var request = themeCardRequests.get(handle);
    if (!request) {
      request = new Promise(function (resolve, reject) {
        themeCardQueue.push({ handle: handle, resolve: resolve, reject: reject });
        pumpThemeCardQueue();
      });
      themeCardRequests.set(handle, request);
      // A failed request may be retried on the next render.
      request.catch(function () {
        themeCardRequests.delete(handle);
      });
    }
    return request;
  }

  function syncThemeCards() {
    document.querySelectorAll("[data-ms-card-handle]:not([data-ms-card-sync])").forEach(function (placeholder) {
      var handle = placeholder.getAttribute("data-ms-card-handle");
      if (!handle) {
        placeholder.setAttribute("data-ms-card-sync", "failed");
        return;
      }
      placeholder.setAttribute("data-ms-card-sync", "pending");
      themeCard(handle).then(
        function (card) {
          // Globo may have re-rendered the grid while the card was loading.
          if (!placeholder.isConnected) return;
          var next = document.importNode(card, true);
          next.setAttribute("data-ms-card-handle", handle);
          next.setAttribute("data-ms-card-sync", "done");
          placeholder.replaceWith(next);
          // The grid is outside Alpine's root, so the cart button needs an explicit init.
          reinitAlpine(next);
        },
        function (e) {
          placeholder.setAttribute("data-ms-card-sync", "failed");
          if (typeof console !== "undefined" && console.warn) {
            console.warn("[globo-integration] theme card failed", e);
          }
        },
      );
    });
  }

  window.addEventListener("globoFilterRenderCompleted", syncThemeCards);
  window.addEventListener("globoFilterTreeRenderCompleted", relocateToolbarControls);
  window.addEventListener("msCollectionGridSorted", relocateToolbarControls);
  window.addEventListener("globoFilterTreeRenderCompleted", syncFilteredCount);
  window.addEventListener("globoFilterTreeRenderCompleted", syncSearchEmptyState);
  window.addEventListener("globoFilterTreeRenderCompleted", syncPillsRowWidth);
  window.addEventListener("resize", syncPillsRowWidth);
  window.addEventListener("globoFilterRenderCompleted", alignSearchSortOptions);
  window.addEventListener("globoFilterTreeRenderCompleted", alignSearchSortOptions);
  relocateToolbarControls();
  syncPillsRowWidth();
  alignSearchSortOptions();
  syncThemeCards();
})();
